import React from 'react';

export const User2 = () => {
  return (
    <svg width={18} height={22} viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.75 11.5c2.734 0 5-2.227 5-5 0-2.734-2.266-5-5-5-2.773 0-5 2.266-5 5 0 2.773 2.227 5 5 5zm3.477 1.25h-.665c-.859.43-1.796.625-2.812.625-1.016 0-1.992-.195-2.852-.625h-.664C2.344 12.75 0 15.133 0 18.023v1.602C0 20.68.82 21.5 1.875 21.5h13.75c1.016 0 1.875-.82 1.875-1.875v-1.602c0-2.89-2.383-5.273-5.273-5.273z"
        fill="#2F6C5E"
      />
    </svg>
  );
};
